import type { ServiceStatus } from '@/lib/schemas/db'

export function formatServiceStatus(value: ServiceStatus): string {
  switch (value) {
    case 'ReadyToInvoice':
      return 'Ready to Invoice'
    case 'Arrived':
      return 'Arrived on site'
    case 'LeftSite':
      return 'Left site'
    case 'NewJob':
      return 'New job'
    case 'ReadyToWork':
      return 'Ready to work'
    case 'InProgress':
      return 'In progress'
    case 'WaitingOnParts':
      return 'Waiting on parts'
    case 'ReadyForCollection':
      return 'Ready for Collection (Success)'
    case 'ReadyForCollectionUnsuccessful':
      return 'Ready for Collection (Unsuccessful)'
    case 'Invoiced':
      return 'Invoiced'
    case 'Review':
      return 'Review'
    case 'Cancelled':
      return 'Cancelled'
    default:
      return value
  }
}

/**
 * The status label split into a base line and an optional outcome qualifier, so
 * long labels (the ready-for-collection variants) can render on two lines. Every
 * other status is a single line with no qualifier.
 */
export function serviceStatusLabelParts(value: ServiceStatus): {
  label: string
  qualifier?: string
} {
  switch (value) {
    case 'ReadyForCollection':
      return { label: 'Ready for Collection', qualifier: 'Success' }
    case 'ReadyForCollectionUnsuccessful':
      return { label: 'Ready for Collection', qualifier: 'Unsuccessful' }
    default:
      return { label: formatServiceStatus(value) }
  }
}
